import { Timestamp } from 'firebase/firestore';
import { getASINReviewHistory, getClientNoteForAsin } from './pmt2LedgerService';

interface NoteEntry {
  date: Timestamp;
  note: string;
  source: 'Standard ASIN Review' | 'Client Note';
  daysAgo: number;
}

const DAYS_FILTER = 35;

const calculateDaysAgo = (timestamp: Timestamp): number => {
  if (!timestamp?.toDate) return 0;
  try {
    const entryDate = timestamp.toDate();
    entryDate.setHours(0, 0, 0, 0);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const diffTime = today.getTime() - entryDate.getTime();
    return Math.max(0, Math.floor(diffTime / (1000 * 60 * 60 * 24)));
  } catch {
    return 0;
  }
};

export const fetchFarmingNotes = async (
  companyName: string,
  asin: string
): Promise<NoteEntry[]> => {
  if (!companyName || !asin) return [];

  try {
    const allNotes: NoteEntry[] = [];
    
    const reviewEntries = await getASINReviewHistory(companyName, asin);
    reviewEntries.forEach((entry) => {
      if (entry.date && entry.note) {
        const daysAgo = calculateDaysAgo(entry.date);
        if (daysAgo <= DAYS_FILTER) {
          allNotes.push({
            date: entry.date,
            note: entry.note,
            source: 'Standard ASIN Review',
            daysAgo
          });
        }
      }
    });

    const clientNoteDoc = await getClientNoteForAsin(companyName, asin);
    if (clientNoteDoc?.entries?.[0]) {
      const entry = clientNoteDoc.entries[0];
      if (entry.date && entry.note) {
        const daysAgo = calculateDaysAgo(entry.date);
        if (daysAgo <= DAYS_FILTER) {
          allNotes.push({
            date: entry.date,
            note: entry.note,
            source: 'Client Note',
            daysAgo
          });
        }
      }
    }

    return allNotes.sort((a, b) => a.daysAgo - b.daysAgo);
  } catch (error) {
    console.error('Error fetching farming notes:', error);
    throw new Error('Failed to fetch notes');
  }
};